import { useState } from 'react';

import ImportacaoQuadroVendedores from '../../components/ImportacaoQuadroVendedores/ImportacaoQuadroVendedores';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function QuadroVendedoresImportacao() {

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });


    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        <ImportacaoQuadroVendedores  setNotifier = {(isSuccess, message) => setNotify({
                isActive: true,
                isSuccessful: isSuccess,
                message: message
            })} />
    </>
}